export const NAME_REGEX = /[0123456789!#$%^&*()+=;:~?<>[\]{}|\\@]/gi
